import { lazy } from "react";
import { BASE_PATH } from "context/SiteSettingsContext/utils";
import { ERouteMappingKeys } from "./routeKeys";

export const howItWorksRoutes = {
  [ERouteMappingKeys.HOW_IT_WORKS]: {
    id: "how-it-works",
    path: "/how-it-works",
    components: {
      [BASE_PATH]: lazy(() =>
        import("pages/Sections/GettingStartedWithUniFi").then((p) => ({
          default: p.GettingStartedWithUniFi,
        })),
      ),
      "multi-site": lazy(() =>
        import("pages/Sections/GettingStartedWithUniFi/MultiSite").then(
          (p) => ({ default: p.MultiSiteDeployment }),
        ),
      ),
      "massive-scale": lazy(() =>
        import("pages/Sections/GettingStartedWithUniFi/MassiveScale").then(
          (p) => ({ default: p.MassiveScaleDeployment }),
        ),
      ),
      large: lazy(() =>
        import("pages/Sections/GettingStartedWithUniFi/RackMounted").then(
          (p) => ({ default: p.RackMountedDeployment }),
        ),
      ),
    },
  },
};
